<template>
  <el-container
    id="pagar-container"
    style="justify-content:center; align-items:center"
    v-loading.fullscreen.lock="loading"
  >
    <el-col
      :xs="24"
      :sm="20"
      :md="15"
      :lg="10"
    >
      <el-row type="flex" justify="end">
        <el-col
          :xs="24"
          :sm="5"
        >
          <el-button
            type="primary"
            @click="$goBack()"
            style="width:100%"
          >
            Volver
          </el-button>
        </el-col>
      </el-row>
      <div class="cart-wrapper">
        <div class="cart-title">
          <h1 class="cart-title__inner">
            Pago de avaluos
          </h1>
        </div>
        <div class="custom-table">
          <div
            class="custom-table__body"
          >
            <div class="custom-row">
              <div class="custom-row__field">
                Folio
              </div>
              <div class="custom-row__value">
                {{ avaluos.Folio }}
              </div>
            </div>
            <div class="custom-row">
              <div class="custom-row__field">
                Descripción
              </div>
              <div class="custom-row__value">
                {{ avaluos.Descripcion }}
              </div>
            </div>
            <div class="custom-row">
              <div class="custom-row__field">
                total
              </div>
              <div class="custom-row__value">
                {{ $currencyFormater(avaluos.Importe) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-row type="flex" justify="end">
        <el-col
          :xs="24"
          :sm="5"
        >
          <el-button
            type="primary"
            class="submit"
            @click="submit"
          >
            Pagar
          </el-button>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="0">
      <form
        id="PagoBancomer"
        name="PagoBancomer"
        action="https://www.adquiramexico.com.mx/clb/endpoint/gzapopan/"
        target="_parent"
        method="post"
      >
        <input
          id="s_transm"
          name="s_transm"
          type="hidden"
          :value="pk"
        >
        <input
          id="c_referencia"
          name="c_referencia"
          type="hidden"
          :value="referencia"
        >
        <input
          id="val_1"
          name="val_1"
          type="hidden"
          value="0"
        >
        <input
          id="val_2"
          name="val_2"
          type="hidden"
          :value="nombrecompletopropietario"
        >
        <input
          id="t_servicio"
          name="t_servicio"
          type="hidden"
          value="226"
        >
        <input
          id="t_importe"
          name="t_importe"
          type="hidden"
          :value="total"
        >
        <input
          id="val_3"
          name="val_3"
          type="hidden"
          value="1"
        >
        <input
          id="val_4"
          name="val_4"
          type="hidden"
          value="1"
        >
        <input
          id="val_5"
          name="val_5"
          type="hidden"
          value="1"
        >
        <input
          id="val_6"
          name="val_6"
          type="hidden"
          value="0"
        >
        <input
          id="val_17"
          name="val_17"
          type="hidden"
          value="0"
        >
        <input
          id="mp_account"
          name="mp_account"
          type="hidden"
          value="439"
        >
        <input
          id="mp_product"
          name="mp_product"
          type="hidden"
          value="1"
        >
        <input
          id="mp_customername"
          name="mp_customername"
          type="hidden"
          :value="nombrecompletopropietario"
        >
        <input
          id="mp_node"
          name="mp_node"
          type="hidden"
          value="0"
        >
        <input
          id="mp_currency"
          name="mp_currency"
          type="hidden"
          value="1"
        >
        <input
          id="mp_amount"
          name="mp_amount"
          type="hidden"
          :value="total"
        >
        <input
          id="mp_signature"
          name="mp_signature"
          type="hidden"
          :value="`${mp_signature}`"
        >
        <input
          id="mp_concept"
          name="mp_concept"
          type="hidden"
          value="2"
        >
        <input
          id="mp_order"
          name="mp_order"
          type="hidden"
          :value="pk"
        >
        <input
          id="mp_reference"
          name="mp_reference"
          type="hidden"
          :value="referencia"
        >
        <input
          id="mp_urlsuccess"
          name="mp_urlsuccess"
          type="hidden"
          :value="'https://prepro.adquiracloud.mx/clb/endpoint/gzapopanResponse'"
        >
        <input
          id="mp_urlfailure"
          name="mp_urlfailure"
          type="hidden"
          :value="'https://prepro.adquiracloud.mx/clb/endpoint/gzapopanResponse'"
        >
      </form>
    </el-col>
  </el-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      url: null,
      nombrecompletopropietario: null,
      referencia: null,
      pk: null,
      total: null,
      mp_signature: null,
    };
  },
  computed: {
    ...mapState({
      avaluos: (state) => state.avaluos,
    }),
  },
  methods: {
    async getResultado() {
      try {
        this.loading = true;
        const param = `${this.pk}${this.referencia}${this.avaluos.Importe}`;
        const res = await this.axios.post('/Encripta', {
          payload: param,
        });
        return res?.data?.resultado;
      } catch {
        return 'error';
      } finally {
        this.loading = false;
      }
    },
    notifyError() {
      this.$ErrorNotify({
        response: {
          data: {
            alerta: 'Ah ocurrido un proceso inesperado vuelva a intentar más tarde',
          },
        },
      });
    },
    async submit() {
      try {
        this.loading = true;
        const resultado = await this.getResultado();
        if (resultado?.toLowerCase() !== 'error') {
          this.mp_signature = resultado;
          const resGuardarRef = await this.axios.post('/GuardarReferenciaDePago', {
            PadronID: this.pk,
            Padron: 'PredioExterno',
            ConceptoAPagar: 2,
            Referencia: this.referencia,
            Cargos: [],
            TotalRedondeo: 0,
            TotalAPagar: parseFloat(this.avaluos.Importe.toFixed(2)),
          });
          if (resGuardarRef?.status === 200 && resGuardarRef?.data
            && typeof resGuardarRef.data === 'boolean') {
            this.$store.dispatch('avaluos/CLEAR_DATA');
            setTimeout(() => {
              document.getElementById('PagoBancomer').submit();
            });
          } else {
            this.notifyError();
          }
        } else {
          this.notifyError();
        }
      } catch (err) {
        this.$ErrorNotify(err);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.referencia = this.avaluos.Folio;
    this.pk = this.avaluos.Folio;
    this.total = this.avaluos.Importe;
    this.nombrecompletopropietario = this.avaluos.nombrecompletopropietario
      || 'propietario de pruebas';
  },
};
</script>

<style lang="scss" scoped>
#pagar-container {
  .submit {
    padding: 0;
    height: 40px;
    width: 100%;
    a {
      width: 100%;
      padding: 12px 20px;
    }
  }
  .el-button {
    background-color: #884E93;
    &:hover {
      opacity: 0.9;
    }
    a {
      text-decoration: none;
      color: #FFFFFF;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .cart-wrapper {
    margin: 10px 0px;
    border: solid #f0f0f0;
    border-width: 1px;
    .cart-title {
      border-radius: 5px 5px 0px 0px !important;
      background-color: #333333;
      color: #FFFFFF;
      padding: 10px;
      .cart-title__inner {
        font-size: 14px;
        padding: 0px !important;
        margin: 0px !important;
      }
    }
    .custom-table {
      padding-left: 10px;
      padding-right: 10px;
      .custom-row {
        display: flex;
        flex-direction: row;
        padding-top: 10px;
        padding-bottom: 10px;
        overflow: hidden;
        text-transform: uppercase;
        border: solid;
        border-width: 0px;
        border-bottom-width: 1px;
        border-color: #f0f0f0;
        &:last-child {
          border-bottom-width: 0px !important;
          .custom-row__value {
            text-align: right;
          }
        }
        .custom-row__field {
          color: #606266;
          min-width: 120px;
          width: 100%;
        }
        .custom-row__value {
          color: #0a0a0a;
          min-width: 120px;
          width: 100%;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .cart-title {
      text-align: center;
    }
  }
}
</style>
